import React from "react";
import PropTypes from "prop-types";

const ResponseRender = ({ response }) => {
  return (
    <div
      className="alert alert-success mt-2"
      style={{ paddingBottom: 10 }}
    >
      <strong>{response}</strong>
    </div>
  );
};

ResponseRender.propTypes = {
  response: PropTypes.string
};

export default ResponseRender;
